<script setup>
  import { ref, defineAsyncComponent, onMounted, useTemplateRef } from 'vue';
  import { useUserStore } from "@/stores/UserStore";
  import { useMutationObserver } from '@vueuse/core'
  import CompleteReportDataContainerSection from '@/components/CompleteReportDataContainerSection.vue';
  import DataContainer from '@/components/DataContainer.vue';
  import useSettingsGlobals from '@/composables/useSettingsGlobals';

  const { $WEB_VIEW } = useSettingsGlobals();

  const ProForecastContainer = defineAsyncComponent(() => import('@/components/ProForecastContainer.vue')); 

  const props = defineProps({
    settings: {
      type: Object,
      required: false
    }
  });  

  const dataContainerSection = useTemplateRef('data-container-section');

  const userStore = useUserStore();

  const content = ref(null);
  const firstForecastTable = ref(null);
  const minHeight = ref(userStore.memberLevel >= 49 && !$WEB_VIEW ? '814px' : userStore.memberLevel >= 49 && $WEB_VIEW ? ' 1000px' : '300px');

  onMounted(() => {
    useMutationObserver(dataContainerSection, (mutations) => {
      if (firstForecastTable.value) return;

      firstForecastTable.value = document.querySelector('.jwx-pro-forecast__spot-forecast-block');
      
      if (firstForecastTable.value) {
        const dataContainerBoundingRect = mutations[0].target.closest('#pro-forecast').getBoundingClientRect();
        const forecastTableBoundingRect = firstForecastTable.value.getBoundingClientRect();
      
        minHeight.value = `${forecastTableBoundingRect.top - dataContainerBoundingRect.top + (forecastTableBoundingRect.height * 2)}px`;
      }
        
    }, {
      childList: true,
      subtree: true,
    })
  }); 
</script>

<template>
  <CompleteReportDataContainerSection
    v-model:content="content"
    ref="data-container-section"
    sectionId="pro-forecast"
    title="Pro Forecast"
    containerTypeId="Operational Forecast"
    containerTypeName="Pro Forecast"
    class="jwx-pro-forecast"
    data-windowed="true"
    :minHeight="minHeight"
    :metaActions="userStore.memberLevel >= 49"
  >
    <template #content="{ isVisible }">
      <DataContainer style="width: 100%; height: 100%;">
        <ProForecastContainer
          v-if="isVisible"
          :minHeight="minHeight"
          :memberLevel="userStore.memberLevel"
        />
      </DataContainer>
    </template>
  </CompleteReportDataContainerSection>
</template>